module.exports = __webpack_public_path__ + "static/media/img33.42614099.jpg";